import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getcustomerOrderHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "customerorder", ...action.payload }),
		);
		yield put({
			type: types.GET_CUSTOMER_ORDER_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_CUSTOMER_ORDER_ERROR,
			payload,
		});
	}
}

export function* getcustomerOrderWatcherSaga() {
	yield takeLatest(types.GET_CUSTOMER_ORDER_START, getcustomerOrderHandlerSaga);
}

//create

//delete

function* deletecustomerOrderHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("customerorder", action.payload),
		);
		yield put({
			type: types.DELETE_CUSTOMER_ORDER_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_CUSTOMER_ORDER_ERROR,
			payload,
		});
	}
}

export function* deletecustomerOrderWatcherSaga() {
	yield takeLatest(
		types.DELETE_CUSTOMER_ORDER_START,
		deletecustomerOrderHandlerSaga,
	);
}

//update
